import { apiRequest } from './client'
import { readInt, readString } from './json'

export type ProductTypeDto = {
  id: number
  parentId: number | null
  code: string
  name: string
  active: boolean
}

type ProductTypeRaw = Record<string, unknown>

const normalizeProductType = (raw: ProductTypeRaw): ProductTypeDto => ({
  id: readInt(raw, 'id', 'id'),
  parentId: raw.parentId != null ? Number(raw.parentId) : raw.parent_id != null ? Number(raw.parent_id) : null,
  code: readString(raw, 'code', 'code') ?? '',
  name: readString(raw, 'name', 'name') ?? '',
  active: raw.active !== false,
})

export const listProductTypes = async (): Promise<ProductTypeDto[]> => {
  const items = await apiRequest<ProductTypeRaw[]>('/product-types')
  return items.map(normalizeProductType)
}
